import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, FormControlLabel, FormGroup, Grid, Paper, Switch, Typography } from '@mui/material';
import { fetchOrgSettingsRequest, updateOrgSettingsRequest } from '../../../api/organizations/orgSlice';
import { showSnackbar } from '../../../api/snackbarSlice';

const SftpSection = () => {
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.org);

  const [sendToSftp, setSendToSftp] = useState(settings?.sftp?.send_pdf || false);

  useEffect(() => {
    dispatch(fetchOrgSettingsRequest());
  }, [dispatch]);

  useEffect(() => {
    if (settings?.sftp_config) {
      setSendToSftp(settings.sftp_config.send_pdf_to_sftp || false);
    }
  }, [settings]);

  const handleSubmit = (updatedSetting) => {
    const updatedSftpSettings = {
      send_pdf_to_sftp: sendToSftp,
      ...updatedSetting,
    };
    dispatch(
      updateOrgSettingsRequest({
        updates: { sftp_config: updatedSftpSettings },
      }),
    );
    dispatch(
      showSnackbar({
        open: true,
        message: 'Organization settings updated successfully',
        severity: 'success',
      }),
    );
  };

  return (
    <Paper elevation={0} sx={{ p: '1rem' }}>
      <Typography variant="h6" sx={{ mb: '1.5rem' }}>
        Auto PDF Generation
        <Divider />
      </Typography>
      <Grid container>
        <Grid size={4.5}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Switch
                  checked={sendToSftp}
                  onChange={() => {
                    setSendToSftp(!sendToSftp);
                    handleSubmit({ send_pdf_to_sftp: !sendToSftp });
                  }}
                />
              }
              label="Send PDF to SFTP"
              labelPlacement="start"
              sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SftpSection;
